// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"beaa24b6","259":"e94341c4","329":"e94341c4","550":"5c03076a","621":"0351b41f","676":"e94341c4","930":"3ab9ab26","962":"66732c80"}[chunkId] + ".chunk.css";
};